module.exports = __webpack_public_path__ + "img/vwc.6f379da5.png";